<div class="group-edit">
  <h2>{{ isNew ? 'Add Group' : 'Edit Group' }}</h2>

  <dx-form [formData]="formData" [colCount]="2" labelLocation="top">
    <dxi-item dataField="name" editorType="dxTextBox" [label]="{ text: 'Name' }">
      <dxi-validation-rule type="required" message="Name is required"></dxi-validation-rule>
    </dxi-item>
    <dxi-item dataField="contact_name" editorType="dxTextBox" [label]="{ text: 'Contact name' }"></dxi-item>
    <dxi-item dataField="contact_email_address" editorType="dxTextBox" [label]="{ text: 'Contact email' }">
      <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
    </dxi-item>
    <dxi-item dataField="contact_phone" editorType="dxTextBox" [label]="{ text: 'Contact phone' }"></dxi-item>
  </dx-form>

  <div class="actions">
    <dx-button text="Save" type="default" (onClick)="save()"></dx-button>
    <dx-button text="Cancel" (onClick)="cancel()"></dx-button>
  </div>

  <div class="members-editor" *ngIf="!isNew">
    <div class="members-header">
      <h3>Locations</h3>
      <div class="add-member">
        <dx-select-box [dataSource]="locations" valueExpr="id" displayExpr="name"
          placeholder="Location" [(value)]="newLocationId"></dx-select-box>
        <dx-button text="Add location" icon="plus" (onClick)="addLocation()"></dx-button>
      </div>
    </div>

    <div class="members-grid-wrap">
      <dx-data-grid
        [dataSource]="members"
        keyExpr="id"
        [showBorders]="true"
        [columnAutoWidth]="true"
        [hoverStateEnabled]="true"
        [noDataText]="'No locations in this group.'"
        height="100%">
        <dxi-column dataField="name" caption="Location"></dxi-column>
        <dxi-column dataField="location_type" caption="Type"></dxi-column>
        <dxi-column dataField="suburb" caption="Suburb"></dxi-column>
        <dxi-column dataField="state" caption="State"></dxi-column>
        <dxi-column type="buttons" caption="" [width]="70">
          <dxi-button hint="Remove" icon="trash" [onClick]="onRemoveClick"></dxi-button>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>

  <p class="hint" *ngIf="isNew">Save the group first, then edit it to add locations.</p>
</div>
